import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {ViewerSettingContentMargin} from './ViewerSettingContentMargin';
import {ViewerSettingDivider} from './ViewerSettingDivider';
import {ViewerSettingFontFamily} from './ViewerSettingFontFamily';
import {ViewerSettingFontSize} from './ViewerSettingFontSize';
import {ViewerSettingLineGap} from './ViewerSettingLineGap';
import {ViewerSettingReadType} from './ViewerSettingReadType';
import {ViewerSettingResetContentOptions} from './ViewerSettingResetContentOptions';
import {ViewerSettingSpaceColor} from './ViewerSettingSpaceColor';
import {ViewerSettingTheme} from './ViewerSettingTheme';
import {ViewerSettingTwoPageLayout} from './ViewerSettingTwoPageLayout';

export const ViewerSetting = Object.assign(ViewerSettingMain, {
  ReadType: ViewerSettingReadType,
  Theme: ViewerSettingTheme,
  SpaceColor: ViewerSettingSpaceColor,
  FontFamily: ViewerSettingFontFamily,
  FontSize: ViewerSettingFontSize,
  LineGap: ViewerSettingLineGap,
  ContentMargin: ViewerSettingContentMargin,
  ResetContentOptions: ViewerSettingResetContentOptions,
  TwoPageLayout: ViewerSettingTwoPageLayout,
  Divider: ViewerSettingDivider,
});

type ViewerSettingMainProps = HTMLAttributes<HTMLDivElement>;

function ViewerSettingMain({
  children,
  className,
  ...props
}: ViewerSettingMainProps) {
  return (
    <div className={twMerge('bg-theme-bg-surface', className)} {...props}>
      {children}
    </div>
  );
}
